export default "__VITE_ASSET__25f7a1e5__"